module.exports = __webpack_public_path__ + "img/背景@0.5x.5e675ba5.png";